import { BaseComponent } from '../../base-component';
import { navigate, hashParams } from '@otto-ec/global-resources/navigation';

export type HashParams = {
    openLayer?: string;
    energyEfficiencyComponent?: string;
};

export class EnergyEfficiencyBaseComponentComponent extends BaseComponent {
    public rootSelector = '.js_pdp_eek';

    public async onHtmlLoaded(): Promise<void> {
        if (this.isPresent()) {
            await this.initEnergyEfficiencyComponent();
        }
    }

    private async initEnergyEfficiencyComponent(): Promise<void> {
        await this.reactToHashInURL();
    }

    private async reactToHashInURL() {
        const params = await hashParams<HashParams>(window.location);

        const openLayer = params.get('openLayer');
        if (openLayer !== 'energyEfficiencyImageLayer') {
            return;
        }

        const componentId = params.get('energyEfficiencyComponent');

        params.delete('openLayer');
        params.delete('energyEfficiencyComponent');
        await navigate(params.toUrl(), { history: 'replace' });

        this.openDetailsSheet(componentId);
    }

    private openDetailsSheet(componentId: string | null) {
        const sheetElements = this.getChildElements<HTMLOcSheetV1Element>('.js_pdp_eek__details-sheet');
        if (componentId) {
            const sheetElement = sheetElements.find(sheetElement => sheetElement.dataset.component === componentId);
            if (sheetElement) {
                sheetElement.open = true;
            }
        } else if (sheetElements.length === 1) {
            sheetElements[0].open = true;
        }
    }
}
